import store from '@/store'; // NOTE: a circular dependency
import repetitionHelper from './repetition-helper';

function courseIdFromStepId(stepId, state) {
    return state.moduleCourse.steps[stepId].courseId;
}

class ScenarioHelper {
    constructor() {
        this.pendingRequests = new Set();
        this.timeoutId = null;
    }
    configure() {
        store.watch(
            state => state.moduleApp.time.startOfCurrentDay,
            val => {
                this.requestUpdateCurrentScenario();
            },
            { immediate: true }
        );
    }

    async updateCurrentScenarioForCourse(courseId) {
        const scenariosInfo = getCourseScenariosInfo(
            courseId,
            store.state.moduleApp,
            store.state.moduleApp.time.startOfCurrentDay
        );
        const newScenarioInfo = scenariosInfo.currentScenarioInfo;

        store.commit('moduleCourse/updateCourseScenariosInfo', { courseId, data: scenariosInfo });

        // -----------------------------
        // Update (delete/create) scenario repetition for courseId
        // -----------------------------

        let reps = repetitionHelper.getRepetitions().filter(r => r.namespace === 'scenarios' && r.itemId === courseId);
        if (reps.length > 1) {
            // NOTE: something wrong, should be max 1 rep
            await Promise.all(reps.map(r => repetitionHelper.deleteRepetition(r.id)));
            reps = [];
        }

        if (!newScenarioInfo && reps.length) {
            await Promise.all(reps.map(r => repetitionHelper.deleteRepetition(r.id)));
            return;
        }

        if (newScenarioInfo) {
            const name = `Scenario ${newScenarioInfo.scenarioIndex + 1} of step ${newScenarioInfo.stepId}`;

            if (reps[0] && reps[0].name === name) {
                return;
            }

            await Promise.all(reps.map(r => repetitionHelper.deleteRepetition(r.id)));

            const yesterday = Date.now() - 86400000;
            repetitionHelper.createRepetition(
                'scenarios',
                courseId,
                name,
                1,
                !newScenarioInfo.pending ? yesterday : null,
                // `${location.origin}/lifeskill/${course.lifeskillNumber}/practice`
                `${location.origin}/from-rep-email`
            );
        }
    }

    requestUpdateCurrentScenario(courseId, stepId) {
        if (!courseId && stepId) {
            courseId = courseIdFromStepId(stepId, store.state);
        }
        if (courseId) {
            this.pendingRequests.add(courseId);
        } else {
            store.state.moduleCourse.courseIds.forEach(courseId => {
                let course = store.state.moduleCourse.courses[courseId];
                // if (course.currentScenarioInfo && course.loadInfo.scenarios) {
                if (course.loadInfo.scenarios) {
                    this.pendingRequests.add(courseId);
                }
            });
        }
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
            Array.from(this.pendingRequests).forEach(courseId => {
                this.updateCurrentScenarioForCourse(courseId);
            });
            this.pendingRequests.clear();
        }, 1000);
    }
}

function getCourseScenariosInfo(courseId, state, startOfCurrentDay) {
    const course = store.state.moduleCourse.courses[courseId];

    const journeysStats = course.stepGroupIds.map(stepGroupId =>
        store.getters['moduleCourse/getStepGroupStats'](stepGroupId)
    );
    const hasLockedHabitJourneys = journeysStats.some(stats => {
        return stats.theoryProgress < 1 && stats.scenariosDoneCount < stats.scenariosTotalCount;
    });
    const largestScenarioTimestamp = journeysStats
        .map(s => s.largestScenarioTimestamp)
        .reduce((largestTimestamp, timestamp) => Math.max(largestTimestamp, timestamp), 0);

    for (let j = 0; j < course.stepGroupIds.length; j++) {
        const journey = store.state.moduleCourse.stepGroups[course.stepGroupIds[j]];
        if (!journey.quiz || !journey.quiz.done) {
            continue;
        }
        for (let s = 0; s < journey.stepIds.length; s++) {
            const step = store.state.moduleCourse.steps[journey.stepIds[s]];
            const scenarioIndex = (step.scenarioIds || [])
                .map(scenarioId => store.state.moduleCourse.scenarios[scenarioId])
                .findIndex(scenario => {
                    return !scenario.done;
                });
            if (scenarioIndex !== -1) {
                return {
                    hasLockedHabitJourneys,
                    currentScenarioInfo: {
                        habitJourneyIndex: journey.index,
                        stepId: step.id,
                        scenarioIndex,
                        pending: startOfCurrentDay < largestScenarioTimestamp
                    }
                };
            }
        }
    }

    return {
        hasLockedHabitJourneys,
        currentScenarioInfo: null
    };
}

const scenarioHelper = new ScenarioHelper();
export default scenarioHelper;
